module.exports = __webpack_public_path__ + "img/resmed_white_logo.04266204.png";